export const ui_var = {
    sidebar_width_lg: '230px',
    sidebar_width_sm: '50px'
}